<ng-template [ngIf]="true">
  <sigecom-content-container [title]="isEditing ? 'Editar sorteio' : 'Cadastrar sorteio'">
    <div buttons>
      <sigecom-button title="SORTEIOS" icon="list" (buttonClicked)="drawList()"></sigecom-button>
    </div>

    <div content>
      <form
        class="flex flex-col gap-2"
        #serviceForm="ngForm"
        (ngSubmit)="onSubmit(serviceForm)"
      >
        <div class="col-span-1">
          <sigecom-input-container
            label="Nome do sorteio"
            [isRequired]="true"
            [errorMessage]="
              messageErrorResolver.showErrorMessageForKey(
                serviceForm,
                'sorTxNome'
              )
            "
          >
            <input
              sigecom-input
              name="sorTxNome"
              type="text"
              required
              [minlength]="5"
              [maxlength]="155"
              [(ngModel)]="drawPostForm.sorTxNome"
              placeholder="Ex: Sorteio das equipes..."
            />
          </sigecom-input-container>
        </div>

        <sigecom-input-container label="Descrição" [isRequired]="false">
          <textarea
            [(ngModel)]="drawPostForm.sorTxDescricao"
            name="sorTxDescricao"
            placeholder="Ex.: Descrição do sorteio"
            type="text"
            sigecom-input
          ></textarea>
        </sigecom-input-container>

        <div class="grid grid-flow-col grid-cols-2 gap-2">
          <sigecom-input-container
            label="Nº máximo de jogos do dia"
            [isRequired]="true"
            [errorMessage]="
              messageErrorResolver.showErrorMessageForKey(
                serviceForm,
                'sorNrNumeroJogosDia'
              )
            "
          >
            <input
              [required]="true"
              sigecom-input
              name="sorNrNumeroJogosDia"
              type="number"
              [(ngModel)]="drawPostForm.sorNrMaxJogosDia"
              placeholder="Ex. 5"
              [min]="0"
            />
          </sigecom-input-container>

          <sigecom-input-container
            label="Tempo de intervalo dos jogos"
            [isRequired]="true"
            [errorMessage]="
              messageErrorResolver.showErrorMessageForKey(
                serviceForm,
                'sorNrIntervaloEntreJogos'
              )
            "
          >
            <input
              [required]="true"
              sigecom-input
              name="sorNrIntervaloEntreJogos"
              type="number"
              [(ngModel)]="drawPostForm.sorNrIntervaloJogos"
              placeholder="Ex. 40"
              [min]="0"
            />
          </sigecom-input-container>
        </div>

        <div class="grid grid-flow-col grid-cols-2 gap-2">
          <sigecom-input-container
            label="Nº máximo de embates simultâneos"
            [isRequired]="true"
            [errorMessage]="
              messageErrorResolver.showErrorMessageForKey(
                serviceForm,
                'sorNrEmbatesSimultaneos'
              )
            "
          >
            <input
              [required]="true"
              sigecom-input
              name="sorNrEmbatesSimultaneos"
              type="number"
              [(ngModel)]="drawPostForm.sorNrMaxEmbSimultaneos"
              placeholder="Ex. 5"
              [min]="0"
            />
          </sigecom-input-container>

          <div
            class="flex flex-col gap-2 border border-sigecom-gray rounded-md px-4 py-2"
          >
            <small class="text-sigecom-outlined-gray font-semibold text-sm">
              Trocar ordem de confronto <b class="text-sigecom-danger">*</b>
            </small>
            <sigecom-switch
              [(switchState)]="drawPostForm.sorBlTrocaOrdemConfronto"
            />
          </div>
        </div>

        <div
          class="grid grid-flow-col grid-cols-3 gap-4 mb-2 w-full"
          *ngIf="!isEditing"
        >
          <div class="col-span-1">
            <sigecom-input-container
              label="Evento"
              [type]="InputTypeEnum.SELECT"
              [isRequired]="true"
              [isDisabled]="isEditing"
              [errorMessage]="
                messageErrorResolver.showErrorMessageForKey(
                  serviceForm,
                  'eveNrId'
                )
              "
            >
              <select
                sigecom-input
                class="w-full"
                [(ngModel)]="eveNrId"
                (change)="loadCompetitionsBlocks($event)"
                required
                name="eveNrId"
              >
                <option [ngValue]="undefined">Selecione...</option>
                <option
                  [value]="event.eveNrId"
                  *ngFor="let event of events?.content"
                >
                  {{ event.eveTxNome }}
                </option>
              </select>
            </sigecom-input-container>
          </div>

          <div class="col-span-1">
            <sigecom-input-container
              label="Bloco de competição da modalidade"
              [type]="InputTypeEnum.SELECT"
              [isRequired]="true"
              [isDisabled]="!eveNrId"
              [errorMessage]="
                messageErrorResolver.showErrorMessageForKey(
                  serviceForm,
                  'bloNrId'
                )
              "
            >
              <select
                sigecom-input
                class="w-full"
                [(ngModel)]="bloNrId"
                (change)="loadCompetitions($event)"
                required
                name="bloNrId"
              >
                <option [ngValue]="undefined">Selecione...</option>
                <option
                  *ngFor="let competitionBlock of competitionsBlocks?.content"
                  [value]="competitionBlock.bloNrId"
                >
                  {{ competitionBlock.bloTxNome }}
                </option>
              </select>
            </sigecom-input-container>
          </div>

          <div class="col-span-1">
            <sigecom-input-container
              label="Competição da modalidade"
              [type]="InputTypeEnum.SELECT"
              [isRequired]="true"
              [isDisabled]="!bloNrId"
              [errorMessage]="
                messageErrorResolver.showErrorMessageForKey(
                  serviceForm,
                  'comNrId'
                )
              "
            >
              <select
                sigecom-input
                class="w-full"
                [(ngModel)]="comNrId"
                (change)="loadCategories($event)"
                required
                name="comNrId"
              >
                <option [ngValue]="undefined">Selecione...</option>
                <option
                  [value]="competition.comNrId"
                  *ngFor="let competition of competitions?.content"
                >
                  {{ competition.comTxNome }}
                </option>
              </select>
            </sigecom-input-container>
          </div>
        </div>

        <sigecom-input-container
          label="Prova"
          [type]="InputTypeEnum.SELECT"
          [isRequired]="true"
          [isDisabled]="!comNrId || isEditing"
          [errorMessage]="
            messageErrorResolver.showErrorMessageForKey(serviceForm, 'catNrId')
          "
        >
        <select
        sigecom-input
        class="w-full"
        [(ngModel)]="drawPostForm.catNrId"
        (change)="changeCategory()"
        required
        name="catNrId"
      >
        <option [ngValue]="undefined">Selecione...</option>
        <option
          [ngValue]="category.catNrId"
          *ngFor="let category of categories?.content"
        >
          {{ category.catTxNome }} - {{ category.catTxSexo }}
        </option>
      </select>

        </sigecom-input-container>

        <div class="col-span-full grid grid-cols-3 gap-x-4 gap-y-2">
          <div class="col-span-full flex flex-col gap-2 text-sigecom-dark-gray">
            <h4>Definir cabeças de chaves</h4>
          </div>

          <sigecom-multiselect-search
            useList
            enableTemplate
            label="Selecione os cabeças de chave"
            [isRequired]="false"
            [options]="registeredsCategory?.content!"
            identifyProperty="insNrId"
            displayProperty="insTxResumo"
            propertyDisplayedInInput="insTxResumo"
            placeHolder="Buscar inscrição"
          >
            <ng-template
              [listTypeInject]="registeredsCategory?.content!"
              let-option
            >
              <div
                class="space-x-2 flex-1 flex items-center justify-between cursor-pointer"
                (click)="onParticipantChange(option)"
              >
                <div
                  class="text-sigecom-outlined-gray font-semibold w-full flex items-center justify-between gap-2"
                >
                  <p>{{ option.insTxResumo! | formatEnum }}</p>
                  <fa-icon icon="add" class="text-xs text-sigecom-info block" />
                </div>
              </div>
            </ng-template>
          </sigecom-multiselect-search>

          <div
            class="col-span-2 border flex flex-col gap-2 border-sigecom-outlined-gray rounded-md p-3 max-h-[18rem] overflow-y-auto"
          >
            <ng-container *ngIf="keyHeaders?.length! === 0; else taeListForm">
              <p class="text-center mt-16 block">Selecione os participantes.</p>
            </ng-container>

            <ng-template #taeListForm>
              <h4 class="font-bold text-sm">Definir cabeças de chaves</h4>
              <div
                class="flex flex-col gap-2 w-full rounded-md text-sigecom-outlined-gray"
                *ngFor="let partList of keyHeaders; let i = index"
              >
                <div
                  class="flex justify-between items-center border px-4 py-2 rounded-md shadow-md"
                >
                <p class="font-semibold">
                  {{ partList.incTxResumo! | formatEnum }}
                </p>

                  <button
                    type="button"
                    class="bg-sigecom-danger text-white w-6 h-6 rounded-md"
                    (click)="removeParticipant(partList.incNrId!)"
                  >
                    <fa-icon icon="trash" class="text-xs" />
                  </button>
                </div>
              </div>
            </ng-template>
          </div>

          <div class="grid grid-cols-2 col-span-full gap-x-4 gap-y-2">
            <div
              class="col-span-full flex flex-col gap-2 text-sigecom-dark-gray"
            >
              <h4>Vincular arena ao sorteio.</h4>
            </div>

            <sigecom-input-container
              label="Arena"
              [type]="InputTypeEnum.SELECT"
              [isRequired]="true"
              [isDisabled]="false"
              [errorMessage]="
                messageErrorResolver.showErrorMessageForKey(
                  serviceForm,
                  'areNrId'
                )
              "
            >
            <select
            sigecom-input
            name="areNrId"
            required
            #resAreNrId
            (change)="setArena(resAreNrId)"
            [(ngModel)]="arenaValue"
          >
            <option [ngValue]="undefined" selected>Selecione...</option>
            <option
              *ngFor="let item of pagedArenas?.content"
              [value]="item.areNrId"
            >
              {{ item.areTxNome }}
            </option>
          </select>

            </sigecom-input-container>
            <div *ngIf="drawPostForm.arenaSorteioFormList?.length">

            <sigecom-input-container
              label="Nº máximo de embates simultâneos"
              [isRequired]="true"
              [errorMessage]="
                messageErrorResolver.showErrorMessageForKey(
                  serviceForm,
                  'arsNrEmbatesSimultaneos'
                )
              "
            >
              <input
                [required]="true"
                sigecom-input
                name="arsNrEmbatesSimultaneos"
                type="number"
                [disabled]="!arenaValue"
                #arsNrEmbatesSimultaneos
                (change)="setEmbateMaxInForm(arsNrEmbatesSimultaneos)"
                placeholder="Ex. 5"
                [min]="0"
                [(ngModel)]="drawPostForm.arenaSorteioFormList![0].arsNrEmbatesSimultaneos"
              />
            </sigecom-input-container>
            </div>
          </div>
        </div>

        <div class="col-span-full mt-4" *ngIf="selectedsArenas.length > 0">
          <p>Arena selecionada:</p>

          <div
            class="bg-gray-200 p-2 rounded-lg mt-2 flex justify-between items-center"
            *ngFor="let arena of selectedsArenas"
          >
            <div>
              <p class="font-bold">{{ arena.areTxNome }}</p>
              <p
                *ngIf="arena.arsNrEmbatesSimultaneos"
                class="text-sm text-gray-600"
              >
                {{
                  "Nº máximo de embates simultâneos: " +
                    arena.arsNrEmbatesSimultaneos
                }}
              </p>
            </div>

            <sigecom-menu-bar-item
              icon="trash"
              color="sigecom-danger"
              title="Deletar"
              (clickAction)="removeArena(arena.areNrId)"
            />
          </div>
        </div>

        <sigecom-action-buttons
          [isSaveDisabled]="!!serviceForm.invalid"
          (cancelClick)="drawList()"
          (saveClick)="onSubmit(serviceForm)"
        >
        </sigecom-action-buttons>

      </form>
    </div>
  </sigecom-content-container>
</ng-template>
